module.exports = __webpack_public_path__ + "static/media/default_phys_services_md.f3b66662.jpeg";